import { QuestionResponseModel } from './question-response-model';

export interface SurveyResponseModel {
  id: string;
  surveyId: string;
  status: number;
  responseContext: number;
  userId: string;
  surveyResponseType: number;
  dateStarted: Date;
  dateCompleted: Date;
  questionResponses: QuestionResponseModel[];
  stop: string;
  start: string;
  continue: string;
  hasExtraValueQuestions: boolean;
  numberOfOthers: number;
  numberOfGroups: number;
  numberOfRespondentsPerGroup: number;
  participantName: string;
}
